import React from 'react'

const IpsaContext = React.createContext({
    status: {},
    userInfo: {},
    subscription: {},
    cardInformation: {},
    refreshUser: async () => {},
})

export default IpsaContext
